module.exports = __webpack_public_path__ + "img/T2C_rc_7.e3c80664.png";